export const FLIGHT_TYPES = [
  "LOCAL",  
  "REGIONAL",
  "INTERNATIONAL"
]